import { getCountries, getCountryCallingCode } from 'libphonenumber-js';
import i18nCountries from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';

i18nCountries.registerLocale(enLocale);

const COUNTRY_NAME_SHORT_OVERRIDE = {
  US: 'US',
  GB: 'UK',
  AE: 'UAE',
  KR: 'Korea',
};

function countryMenuLabel(iso) {
  if (COUNTRY_NAME_SHORT_OVERRIDE[iso]) return COUNTRY_NAME_SHORT_OVERRIDE[iso];
  return i18nCountries.getName(iso, 'en') || iso;
}

export const PHONE_COUNTRY_OPTIONS = getCountries()
  .map((iso) => {
    const dialDigits = String(getCountryCallingCode(iso)).replace(/\D/g, '');
    return {
      code: iso,
      label: countryMenuLabel(iso),
      dialDigits,
      dialDisplay: dialDigits ? `+${dialDigits}` : '',
    };
  })
  .filter((c) => c.dialDigits.length > 0)
  .sort((a, b) => {
    if (a.code === 'IN') return -1;
    if (b.code === 'IN') return 1;
    return a.label.localeCompare(b.label, undefined, { sensitivity: 'base' });
  });

export function findPhoneCountryByCode(iso) {
  return PHONE_COUNTRY_OPTIONS.find((c) => c.code === iso);
}

/** Best-effort ISO from stored E.164 (longest calling-code prefix wins). */
export function defaultPhoneCountryFromE164(phoneE164) {
  if (!phoneE164 || typeof phoneE164 !== 'string') return 'IN';
  const digits = phoneE164.replace(/\D/g, '');
  if (!digits) return 'IN';
  const sorted = [...PHONE_COUNTRY_OPTIONS].sort((a, b) => b.dialDigits.length - a.dialDigits.length);
  for (const c of sorted) {
    if (digits.startsWith(c.dialDigits)) return c.code;
  }
  return 'IN';
}

export function nationalDigitsFromE164(phoneE164, iso) {
  const row = findPhoneCountryByCode(iso);
  if (!row || !phoneE164) return '';
  const d = phoneE164.replace(/\D/g, '');
  if (!d.startsWith(row.dialDigits)) return '';
  return d.slice(row.dialDigits.length);
}

export function toFullE164(iso, nationalDigitsRaw) {
  const row = findPhoneCountryByCode(iso);
  if (!row) return null;
  const national = String(nationalDigitsRaw || '').replace(/\D/g, '');
  if (!national) return null;
  if (national[0] === '0') return null;
  const full = row.dialDigits + national;
  if (full.length < 8 || full.length > 15) return null;
  return `+${full}`;
}
